<ng-container *ngIf="portalLead$ | async as portalLead; else loadingTemplate">
  <header
    [salesAgent]="portalLead.salesAgent"
    [showLoginButton]="showLoginButton"
    class="header"
  ></header>

  <div class="d-flex mx-auto pt-md-10 content justify-content-center">
    <router-outlet />
  </div>

  <footer [ngClass]="{ 'with-bar': isBar }"></footer>
</ng-container>

<ng-template #loadingTemplate>
  <lead-loading-page />
</ng-template>
